import { render, staticRenderFns } from "./ALMA_SettingsWindow.vue?vue&type=template&id=4f555bf7&scoped=true"
import script from "./ALMA_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./ALMA_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f555bf7",
  null
  
)

export default component.exports